module.exports = __webpack_public_path__ + "media/images/hamb-black-059c641310267f5b4dcb0150d002d732.svg";